<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>

        <v-layout justify-space-between mb-7>
          <v-flex shrink>
            <v-layout>
              <v-flex pt-3 mr-4>
                ชื่อ หรือ นามสกุล :
              </v-flex>
              <v-flex mr-4>
                <v-text-field
                    solo
                    flat
                    v-model="keywordName"
                    @keyup.enter="searchName"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex shrink>
            <InputForm :type="section"></InputForm>
          </v-flex>
        </v-layout>

        <div class="mb-7 cea-underline"></div>

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>

        <v-layout v-if="section === 'users'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
                <tr>
                  <td width="5%">ลำดับ</td>
                  <td width="25%">ชื่อจริง</td>
                  <td width="25%">นามสกุล</td>
                  <td width="20%">อีเมล</td>
                  <td width="20%">ชื่อผู้ใช้งาน</td>
                  <td width="5%">แก้ไข</td>
                </tr>
              </thead>
              <tbody>

                <tr v-for="(item,i) in accountList.data" :key="i">
                  <td>{{item.user_id}}.</td>
                  <td class="text-start">{{item.first_name}}</td>
                  <td class="text-start">{{item.last_name}}</td>
                  <td class="text-start">{{item.email}}</td>
                  <td class="text-start">{{item.username}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.user_id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationAccount.total > 0">
                <v-pagination v-model="paginationAccount.current"
                              :length="paginationAccount.total"
                              v-if="accountLoaded"
                              @input="onAccountPageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>


      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import Header from '../components/Header'
  import InputForm from "../components/InputForm"
  import Service from '../services'
  import { mapState, mapActions } from 'vuex'
  import Loading from 'vue-loading-overlay'

export default {
  name: 'user-manager',
  props: ['section'],
  components: {
    Header,
    InputForm,
    Loading
  },
  data: () => ({
    dataParam: {},
    keywordName: '',
    pageVisible: 8,
    paginationAccount: {
      current: 1,
      total: 1,
      itemPerPage: 10
    },
    accountLoaded: false,
    sectionLoaded: true
  }),
  created() {
    this.dataParam.token = this.userData.token;
    this.onGetAllAccountPaginate(this.dataParam).then(() => {
      this.onAccountPageChange();
    });
  },
  watch: {
    // re-render pagination
    section: function () {
      this.accountLoaded = false;
      setTimeout(() => {
        this.accountLoaded = true;
      }, 1);
    }
  },
  computed: {
    ...mapState({
      userData: state => state.auth.userData,
      accountList: state => state.auth.allAccountPaginate
    })
  },
  methods: {
    ...mapActions('auth',['onGetAllAccountPaginate']),
    onAccountPageChange(page) {
      let data = { page: page, token: this.userData.token };

      this.paginationAccount.total = Math.ceil(this.accountList.total / this.paginationAccount.itemPerPage);

      Service.auth.getAllAccountPaginate(data).then((res) => {
        this.paginationAccount.current = res.current_page;
        this.accountList.data = res.data;
        this.accountLoaded = true;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })

    },
    searchName () {
      let param = { keyword: this.keywordName, token: this.userData.token };
      this.sectionLoaded = true;

      if (param.keyword === '') {
        this.onGetAllAccountPaginate(this.dataParam).then(() => {
          this.onAccountPageChange();
        }).then(() => {
          this.sectionLoaded = false;
        })
        return;
      }

      Service.auth.searchName(param).then((res) => {
        this.accountList.data = res;
        this.accountLoaded = false;
      }).then(() => {
        this.sectionLoaded = false; // set finish loading
      })
    }
  }
}
</script>

<style scoped>

  .theme--light.v-data-table thead tr td:not(:last-child),
  .theme--light.v-data-table tbody tr td:not(:last-child) {
    border-right: solid 1px #D7D7D7 !important;
  }

</style>
